import { render, staticRenderFns } from "./PlateTitle.vue?vue&type=template&id=4a282dee&scoped=true&"
import script from "./PlateTitle.vue?vue&type=script&lang=js&"
export * from "./PlateTitle.vue?vue&type=script&lang=js&"
import style0 from "./PlateTitle.vue?vue&type=style&index=0&id=4a282dee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a282dee",
  null
  
)

export default component.exports